import { useState, useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faTrashCan } from "@fortawesome/free-regular-svg-icons";
import { faMoneyBillTransfer } from "@fortawesome/free-solid-svg-icons";
import Modal from "../../Components/Modal/Modal";
import axios from "axios";
import { getDocs, collection } from "firebase/firestore";
import { db } from "../../firebase";
import "./admin.css";
import { Button } from "@mui/material";
import UserModal from "../../Components/Modal/UserModal";

const Admin = () => {
	const { user } = useOutletContext();
	const [selectState, setSelectState] = useState("users");
	const [wallets, setWallets] = useState([]);
	const [modalParams, setModalParams] = useState({
		type: "",
		open: false,
		title: "",
		item: {},
		wallets,
	});
	const [userModalParams, setUserModalParams] = useState({
		open: false,
		user: {},
		type: "",
	});
	const [users, setUsers] = useState([]);
	const fetchUsers = async () => {
		try {
			const usersCollection = collection(db, "users"); // Ссылка на коллекцию users
			const usersSnapshot = await getDocs(usersCollection); // Получение всех документов коллекции
			const allUsers = usersSnapshot.docs.map((doc) => ({
				id: doc.id, // Сохранение ID документа
				...doc.data(), // Сохранение остальных данных
			}));

			setUsers(allUsers); // Устанавливаем состояние с массивом пользователей
			console.log("Все пользователи:", allUsers);
		} catch (error) {
			console.error("Ошибка при получении пользователей:", error);
		}
	};

	useEffect(() => {
		fetchUsers();
		axios
			.get("http://localhost:3001/wallets")
			.then((response) => setWallets(response.data))
			.catch((error) => console.error("Ошибка загрузки JSON:", error));
	}, []);

	const handleClose = () => {
		setModalParams({ ...modalParams, open: false });
		setUserModalParams({ ...userModalParams, open: false });
	};

	const handleOpen = (title, item, type) => {
		setModalParams({ open: true, title, item, type, wallets });
	};

	const handleUserModalOpen = (user, type) => {
		setUserModalParams({ open: true, user, type });
	};

	const dateFormater = (date) => {
		const newDate = new Date(date);
		return `${newDate.getDate()}.${
			newDate.getMonth() + 1
		}.${newDate.getFullYear()} ${newDate.getHours()}:${newDate.getMinutes()}`;
	};

	return (
		<div className="admin">
			{user.role === "admin" ? (
				<>
					<div className="admin-header">
						<div
							className={
								selectState === "users"
									? "admin-header-item-active"
									: "admin-header-item"
							}
							onClick={() => setSelectState("users")}
						>
							Пользователи
						</div>
						<div
							className={
								selectState === "wallets"
									? "admin-header-item-active"
									: "admin-header-item"
							}
							onClick={() => setSelectState("wallets")}
						>
							Кошельки
						</div>
					</div>
					{selectState === "wallets" ? (
						<div className="admin-wrapper">
							<Modal
								open={modalParams.open}
								type={modalParams.type}
								title={modalParams.title}
								item={modalParams.item}
								wallets={modalParams.wallets}
								handleClose={handleClose}
								setWallets={setWallets}
							/>
							<h2 className="admin-title">Кошельки проекта</h2>
							<Button
								onClick={() => handleOpen("Добавить кошелёк", {}, "add")}
								variant="contained"
								sx={{ mb: 2, width: "275px" }}
							>
								Добавить кошелёк
							</Button>
							<table className="admin-table">
								<thead>
									<tr>
										<th>Тип</th>
										<th>Заголовок</th>
										<th>Номер Счёта</th>
										<th>Действия</th>
									</tr>
								</thead>
								<tbody>
									{wallets.map((wallet, i) =>
										wallet.category === "Криптовалюта"
											? wallet.wallets.map((item, i) => (
													<tr key={item.wallet + i}>
														<td>{wallet.category}</td>
														<td>{item.title}</td>
														<td>{item.wallet}</td>
														<td>
															<div className="admin-table-actions">
																<FontAwesomeIcon
																	icon={faPenToSquare}
																	style={{ cursor: "pointer" }}
																	onClick={() =>
																		handleOpen(
																			`Редактировать ${item.title} кошелек`,
																			item,
																			"edit"
																		)
																	}
																/>
																<FontAwesomeIcon
																	icon={faTrashCan}
																	style={{ cursor: "pointer" }}
																	onClick={() =>
																		handleOpen(`Удалить ${item.title} кошелек?`, item, "delete")
																	}
																/>
															</div>
														</td>
													</tr>
											  ))
											: wallet.wallets.map((item, i) => (
													<tr key={item.wallet + i}>
														<td>{wallet.category}</td>
														<td>{item.title}</td>
														<td>{item.wallet}</td>
														<td>
															<div className="admin-table-actions">
																<FontAwesomeIcon
																	icon={faPenToSquare}
																	style={{ cursor: "pointer" }}
																	onClick={() =>
																		handleOpen(`Редактировать ${item.title} счёт`, item, "edit")
																	}
																/>
																<FontAwesomeIcon
																	icon={faTrashCan}
																	style={{ cursor: "pointer" }}
																	onClick={() =>
																		handleOpen(`Удалить ${item.title} кошелек?`, item, "delete")
																	}
																/>
															</div>
														</td>
													</tr>
											  ))
									)}
								</tbody>
							</table>
						</div>
					) : (
						<div className="admin-wrapper">
							<UserModal
								open={userModalParams.open}
								handleClose={handleClose}
								user={userModalParams.user}
								type={userModalParams.type}
								fetchUsers={fetchUsers}
							/>
							<h2 className="admin-user-title">Пользователи</h2>
							<table className="admin-table admin-user-table">
								<thead>
									<tr>
										<th>Email</th>
										<th>Имя и Фамилия</th>
										<th>Баланс</th>
										<th>Дата регистрации</th>
										<th>Прибыльные сделки</th>
										<th>Убыточные сделки</th>
										<th>Депозиты</th>
										<th>График баланса</th>
										<th>История Транзакций</th>
										<th>Сбережения</th>
										<th>Инвестировано</th>
										<th>PNL</th>
										<th>Средний % инвестиций</th>
										<th>Действия</th>
									</tr>
								</thead>
								<tbody>
									{users?.map((user, i) => {
										return (
											<tr key={user.email + i}>
												<td>{user.email}</td>
												<td>
													{user.name} {user.surname}
												</td>
												<td>$ {user.balance}</td>
												<td>{dateFormater(user.createdAt)}</td>
												<td>{user.profitableTrades}</td>
												<td>{user.unprofitableTrades}</td>
												<td>{user.deposits}</td>
												<td>{user.balanceChart}</td>
												<td>{user.transactions}</td>
												<td>{user.savings}</td>
												<td>{user.invested}</td>
												<td>{user.pnl}</td>
												<td>{user.averageInvestment}</td>
												<td>
													<div className="admin-table-actions">
														<FontAwesomeIcon
															icon={faMoneyBillTransfer}
															style={{ cursor: "pointer" }}
															onClick={() => handleUserModalOpen(user, "edit")}
														/>
														<FontAwesomeIcon
															icon={faTrashCan}
															style={{ cursor: "pointer" }}
															onClick={() => handleUserModalOpen(user, "delete")}
														/>
													</div>
												</td>
											</tr>
										);
									})}
								</tbody>
							</table>
						</div>
					)}
				</>
			) : (
				<p className="admin-title">Страница не найдена</p>
			)}
		</div>
	);
};

export default Admin;
